import { render, staticRenderFns } from "./screening.vue?vue&type=template&id=06211504&"
import script from "./screening.vue?vue&type=script&lang=js&"
export * from "./screening.vue?vue&type=script&lang=js&"
import style0 from "./screening.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports